import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-left",
  "use": "app-icon-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-left\"><path d=\"M10.919 14.086a.6.6 0 00.063-.774l-.063-.074-5.233-5.233 5.233-5.232a.6.6 0 00.063-.774l-.063-.075a.6.6 0 00-.774-.063l-.075.063-5.656 5.657a.6.6 0 00-.064.774l.064.075 5.656 5.656a.6.6 0 00.849 0z\" fill=\"#4D4D4D\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol